// Mock data for Sharkbowl Games sleek clone
// NOTE: All data below is MOCKED for frontend-only demo.

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Games", href: "#works" },
  { label: "Blog", href: "#blog" },
  { label: "Contact", href: "#contact" },
];

export const SOCIALS = [
  { name: "Facebook", icon: "facebook", href: "#" },
  { name: "Twitter", icon: "twitter", href: "#" },
  { name: "Instagram", icon: "instagram", href: "#" },
];

export const TEAM = [
  {
    name: "Tarik Bensaria",
    role: "Chief Shark & Co-founder",
    img: "/team/tarik.jpg",
    twitter: "https://twitter.com/TBensaria",
    bio: "The big-picture dreamer chasing that 'just one more go' magic in every game we ship.",
  },
  {
    name: "Shan Blackwood",
    role: "Chief Tech Shark & Co-founder",
    img: "/team/shan.jpg",
    twitter: "https://twitter.com/sirshadaloo",
    bio: "Engineering wizard turning wild concepts into buttery-smooth gameplay.",
  },
];

export const STATS = [
  { value: "3+", label: "Games Shipped" },
  { value: "120K+", label: "Players Reached" },
  { value: "London", label: "Based In" },
  { value: "\u221E", label: "Ideas Brewing" },
];

export const GAMES_FALLBACK = [
  {
    id: "punch-champs", title: "Punch Champs", category: "featured", accent: "#f97316",
    buttonLabel: "Play Demo", officialSite: "https://punchchamps.com/",
    steamLink: "https://store.steampowered.com/app/2975930/PUNCH_CHAMPS/",
    genre: "Tactical 2D Fighter", platforms: ["Steam"], year: "2025",
    image: "https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/2975930/header.jpg",
    description: "Get ready to rumble in this tactical 2D fighter, where mind games beat reflexes.",
    screenshots: [], trailer: null,
  },
  {
    id: "star-shredders", title: "Star Shredders", category: "featured", accent: "#8b5cf6",
    buttonLabel: "Buy Now", officialSite: "https://starshredders.com/",
    steamLink: "https://store.steampowered.com/app/764090/STAR_SHREDDERS/",
    genre: "Retro Space Shooter", platforms: ["Steam"], year: "2024",
    image: "https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/764090/header.jpg",
    description: "A prologue to an extensive, story-rich SHMUP with strategic elements.",
    screenshots: [], trailer: null,
  },
  {
    id: "paddle-up", title: "PaddleUP!", category: "featured", accent: "#06b6d4",
    buttonLabel: "Buy Now", officialSite: null,
    steamLink: "https://store.steampowered.com/app/4396750/PaddleUP/",
    genre: "Arcade Paddle Game", platforms: ["Steam"], year: "2025",
    image: "https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/4396750/de93bd83694216aa248d4d184e290bdf793f04d2/header.jpg",
    description: "A loud, fast arcade paddle game where you keep the ball alive using trick shots.",
    screenshots: [], trailer: null,
  },
  {
    id: "type-fighters", title: "Type Fighters", category: "featured", accent: "#10b981",
    buttonLabel: "Buy Now", officialSite: null,
    steamLink: "https://store.steampowered.com/app/4912720/Type_Fighters/",
    genre: "Typing Fighter", platforms: ["Steam"], year: "2025",
    image: "https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/4912720/e60eebc90a6507a65c7e9ca9b83f5faa8e5e2dda/header.jpg",
    description: "Type to attack. Discover hidden moves. Win. Master 15 unique fighters.",
    screenshots: [], trailer: null,
  },
  { id: "overflow", title: "Overflow", category: "coming-soon", accent: "#0ea5e9", genre: "In Development" },
  {
    id: "cubee", title: "Cubee & The Lost Worlds", category: "featured", accent: "#f59e0b",
    buttonLabel: "Play the Demo", externalLink: "https://sharkbowlgames.itch.io/cubee-and-the-lost-worlds",
    officialSite: null, genre: "Cozy Puzzle Adventure", platforms: ["Browser (itch.io)", "Steam (soon)"],
    year: "2026", hasDemo: true, price: { final: "Free", initial: "Free", discount: 0 },
    image: "/cubee/presspack/key-art.png",
    logo: "/cubee/presspack/logo.png",
    description: "A cozy cube-rolling puzzle adventure where every roll changes Cubee's top face. Play the free demo of 12 handcrafted puzzles across four lost worlds, with the full game coming to Steam.",
    screenshots: ["/cubee/presspack/screenshots/menu.jpg", "/cubee/presspack/screenshots/desert.jpg", "/cubee/presspack/screenshots/crystal-mine.jpg", "/cubee/presspack/screenshots/jungle-temple.jpg"],
    trailer: { youtubeId: "jmu7UABowqI", name: "Official Demo Trailer", thumbnail: "/cubee/presspack/trailer-end-card.jpg" },
  },
  {
    id: "blow-me-up-dude", title: "Blow Me Up Dude", category: "archived", accent: "#ec4899",
    buttonLabel: "View on IndieDB", externalLink: "https://www.indiedb.com/games/blow-me-up-dude-bmud",
    genre: "Comical Arcade Shooter", platforms: ["Windows", "Mac", "Linux", "PS4"], year: "2016",
    image: "/bmu7-cover.jpg",
    logo: "/bmu7-logo.png",
    description: "A comical arcade shooter where shooting opponents makes them GROW until they blow up!",
    screenshots: ["/bmud/ss1.jpg", "/bmud/ss2.png", "/bmud/ss3.jpg", "/bmud/ss4.jpg"], trailer: { mp4: "/bmud/trailer.mp4", name: "BMUD Gameplay (WIP)", thumbnail: "/bmu7-cover.jpg" },
  },
];

export const POSTS = [
  {
    id: 1,
    title: "From AAA to Indie: Why Events Like New Game Plus Matter",
    category: "Industry Updates",
    date: "April 21, 2026",
    read: "4 min",
    img: "https://images.unsplash.com/photo-1558008258-7ff8888b42b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxlc3BvcnRzJTIwZXZlbnR8ZW58MHx8fHwxNzg1NDI1MTQwfDA&ixlib=rb-4.1.0&q=85",
    excerpt: "There's something quietly powerful happening in games right now. Ten years ago, expos were dominated by giants...",
  },
  {
    id: 2,
    title: "PUNCH CHAMPS \u2013 Feedback Update",
    category: "Development",
    date: "September 29, 2025",
    read: "2 min",
    img: "https://images.unsplash.com/photo-1723792306904-c417c0da40e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxnYW1pbmclMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzg1NDI1MTQ5fDA&ixlib=rb-4.1.0&q=85",
    excerpt: "A huge thank you to everyone who downloaded the demo, played a match and shared their thoughts with us...",
  },
  {
    id: 3,
    title: "From Idea to Demo: The First Steps of PUNCH CHAMPS",
    category: "Game Design",
    date: "September 15, 2025",
    read: "3 min",
    img: "https://images.unsplash.com/photo-1616440537338-1d04df3987f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxnYW1pbmclMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzg1NDI1MTQ5fDA&ixlib=rb-4.1.0&q=85",
    excerpt: "Our first post on the development of PUNCH CHAMPS and the initial spark that started it all...",
  },
];

export const CONTACT_INFO = {
  email: "info@sharkbowlgames.com",
  emailDisplay: "info[at]sharkbowlgames.com",
  location: "London, United Kingdom",
  note: "For questions about our company and products, drop us a message. For business enquiries, use our email.",
};